import React, { useState } from 'react';
// import { graphql } from 'gatsby';
import styled from 'styled-components';
import bg from '../images/post_bg.svg';
import { mediaBreakpointDown, mediaBreakpointUp } from '../utils/styling';
import Header from '../components/Header';
import Link from '../components/Link';
import SEO from '../components/Seo/index';
import PostBody from '../components/PostBody';
import House from '../images/home.inline.svg';
import ArrowDown from '../images/chevron-down.inline.svg';
import PostSidebar from '../components/PostSidebar';
import NewFooter from '../components/NewFooter';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import PostCTA from '../components/PostCTA';
import { smbCategories } from '../utils/smbCategories';
import { symbolParse } from "../utils/symbolparse";
import { useTracking } from "../components/Tracking/index";
import InPostTooltip from '../components/Authors/inPostToolTip';
import PostStructuredData from '../components/Authors/postStructuredData';
// import PostBreadcrumbsStructuredData from '../components/StructuredData/postBreadCrumbsStructuredData';
import { getSchemaForPost, hasSchema } from "../utils/schemaMapping";
import { checkContentTags } from '../utils/checkContentTags';

const HeroBanner = styled.section`
	width: 100%;
	${mediaBreakpointDown('sm')} {
		margin-bottom: 27px;
	}
`;

const HeroImage = styled.div`
	background-image: url('${bg}');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: bottom center;
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: #ffd3e8;
`;
const HeroContent = styled.div`
	max-width: 1166px;
	min-height: 520px;

	margin: 0 auto 50px auto;
	width: 100%;
	flex: 1 1;
	padding: 30px 20px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	${mediaBreakpointDown('md')} {
		margin: 0 auto;
		min-height: 320px;
	}
	position: relative;
`;
const HeroTitle = styled.p`
	letter-spacing: -0.043em;
	line-height: 1.1em;
	font-size: 70px;
	color: #002047;
	margin: 0 0 35px 0;
	max-width: 760px;
	font-weight: 700;

	${mediaBreakpointUp('xl')} {
		font-size: 64px;
	}
	${mediaBreakpointDown('lg')} {
		font-size: 60px;
	}
	${mediaBreakpointDown('md')} {
		display: flex;
		align-items: center;
		font-size: 50px;
		min-height: 130px;
	}
	${mediaBreakpointDown('sm')} {
		min-width: 300px;
		min-height: 100px;
		font-size: 40px;
	}
	${mediaBreakpointDown('xs')} {
		font-size: 35px;
		margin-bottom: 25px;
		min-height: 130px;
	}
`;
const HeroLongTitle = styled.p`
	letter-spacing: -0.043em;
	line-height: 1.1em;
	font-size: 70px;
	color: #002047;
	margin: 0 0 35px 0;
	max-width: 760px;
	font-weight: 700;
	${mediaBreakpointUp('xl')} {
		font-size: 64px;
	}
	${mediaBreakpointDown('lg')} {
		font-size: 60px;
	}
	${mediaBreakpointDown('md')} {
		display: flex;
		align-items: center;
		font-size: 50px;
	}
	${mediaBreakpointDown('sm')} {
		min-width: 300px;
		min-height: 220px;
		font-size: 40px;
	}
	${mediaBreakpointDown('xs')} {
		font-size: 35px;
		margin-bottom: 25px;
		min-height: 266px;
	}
`;
const HeroButtonContainer = styled.div``;

const HeroButton = styled.button`
	font-size: 16px;
	padding: 20px 32px;
	border-radius: 8px;
	color: #fffffff6;
	background-color: #e01efe;
	border: 1px solid #e01efe;
	transition: all 0.3s ease-in-out 0s;
	line-height: 1em;
	font-weight: 600;
	cursor: pointer;
	:hover {
		border: 1px solid white;
	}
	width: 300px;

	${mediaBreakpointDown('xs')} {
		padding: 15px 20px;
		font-size: 14px;
		width: 220px;
	}
`;
const Category = styled.span`
	margin-bottom: 17px;
	width: 100%;
	min-height: 40px;

	${mediaBreakpointDown('md')} {
		min-height: 30px;
	}
	${mediaBreakpointDown('sm')} {
		min-height: 23px;
	}

	> a {
		cursor: pointer;
		line-height: 1.2em;
		color: #a44d81ea;
		font-weight: 500;
		font-size: 16px;
		min-height: 22px;
	}
`;
const Breadcrumbs = styled.nav`
	display: flex;
	flex-direction: row;
	padding: 0 0 20px 0;
	flex-wrap: wrap;
	align-items:center;
	${mediaBreakpointDown('md')} {
		align-items: center;
		align-content: center;
		min-height: 70px;
	}
	${mediaBreakpointDown('sm')} {
		min-height: 70px;
		padding: 0;
	}
	${mediaBreakpointDown('xs')} {
		min-height: 80px;
	}
`;
const Breadcrumb = styled.span`
	color: #9db1c380;
	font-size: 12px;
	font-style: italic;
	font-weight: 600;
	font-family: Poppins, Helvetica, Arial, sans-serif;
	text-decoration: none;
	@media only screen and (min-width: 531px) {
		font-size: 12px;
	}
	&:hover {
		color: #e01efe;
	}
`;
const BreadcrumbNoHover = styled.span`
	// color: #d8d8d8;
	color: #d8d8d8da;
	font-size: 12px;
	font-style: italic;
	font-weight: 600;
	font-family: Poppins, Helvetica, Arial, sans-serif;
	padding-top: 1px;
	text-decoration: none;
	@media only screen and (min-width: 531px) {
		font-size: 12px;
	}
`;
const PostSection = styled.section`
	max-width: 1170px;
	padding: 0 20px;
	margin: 0 auto;
	width: 100%;
`;
const PostContainer = styled.div`
	display: flex;
	align-items: stretch;
	${mediaBreakpointDown('md')} {
		flex-direction: column;
	}
`;
const PostContent = styled.div`
	flex: 1 1;
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	justify-content: flex-start;
	overflow: hidden;
	${mediaBreakpointDown('sm')} {
		flex-direction: column;
	}
`;
const Sidebar = styled.div`
	width: 370px;
	margin-left: 100px;
	${mediaBreakpointDown('md')} {
		margin-left: 0;
		width: 100%;
	}
`;
const ButtonA = styled.button`
	border-radius: 50%;
	position: absolute;
	width: 47px;
	height: 47px;
	bottom: -20px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	box-shadow: 0 20px 40px rgba(50, 75, 93, 0.1), 0 8px 16px rgba(0, 0, 0, 0.05);
	color: #db7093;

	${mediaBreakpointUp('lg')} {
		bottom: -70px;
	}
`;
const AuthorSection = styled.div`
	display: flex;
	color: #617792;
	font-weight: 400;
	font-size: 16px;
	align-items: center;
	${mediaBreakpointDown('md')} {
		justify-content: flex-start;
	}
`;
const AuthorImage = styled.img`
	border-radius: 50%;
	border: 5px solid rgba(224,30,254,0.30);
	width: 50px;
	height: 50px;
	object-fit: cover !important;
`;
const AuthorName = styled.span`
	padding-left: 5px;
	color: #617792;
	text-decoration: underline;
`;
const AuthorDetails = styled.p`
	cursor: pointer;
	margin: 0px 0px 0px 5px;
	width: 16px !important;
	height: 16px !important;
	padding: 7px;
	border-radius: 50%;
	display:flex;
	flex-direction:column;
	align-items:center;
	justify-content:center;
	font-family: Georgia, Times New Roman, sans-serif;
	font-style: italic;
	font-size: 12px;
	font-weight: 900;
	color: #617792;
	border: 1px solid #617792;
`;
const Disclaimer = styled.div`
	border: 2px solid #E1E8EF;
	padding: 10px 25px 10px 10px;
	border-radius: 10px;
	color: #364175;
	font-weight: 500;
	// display: flex;
	// align-items: flex-start;
	// justify-content: center;
	width: 100%;
	margin: 60px 0 50px 0;
	font-size: 12px;
	@media only screen and (max-width: 531px) {
		margin: 0 0 0 0;
		font-size: 11px;
	}
`;
const I = styled.span`
	margin: 0 10px 0 0;
	width: 15px !important;
	height: 15px !important;
	padding: 1px;
	border-radius: 50%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-family: Georgia, Times New Roman, sans-serif;
	font-style: italic;
	font-size: 12px;
	font-weight: 900;
	color: #F727FF;
	background-color: #FFD8FF;
	display: inline-block;
	text-align: center;

`;
const linkStylesBreadCrumbs = {
	textDecoration: 'none',
	display: 'inline',
	paddingRight: '15px',
	margingBottom: '0',
	paddingBottom: '0',
	paddingLeft: '0',
	fontWeight: '700',
};
const alignHouse = {
	paddingTop: '3px',
};


export default function Post({
	pageContext: { canonical, post },
	// data: {
	// 	cms: { post },
	// },
	// ...props
}) {
	const category = post.category || {};
	const [isOpen, setIsOpen] = useState(false);

	const dnpUrl = smbCategories[category.name]
		? `${process.env.MAIN_SITE_URL}/business?cta=${post.slug}&ref=learn`
		: `${process.env.MAIN_SITE_URL}/${post.slug}?cn=${category.name.replace("&amp;", "and")}&ref=learn`;

	if (post.seo && post.seo.breadcrumbTitle) {
		post.seo.breadcrumbTitle = symbolParse(post.seo.breadcrumbTitle)
		// if (post.seo.breadcrumbTitle.includes('&amp;')) {
		// 	post.seo.breadcrumbTitle = post.seo.breadcrumbTitle.replace('&amp;', '&');
		// }
		// if (post.seo.breadcrumbTitle.includes('&#8217;')) {
		// 	post.seo.breadcrumbTitle = post.seo.breadcrumbTitle.replace('&#8217;', "'");
		// }
		// if (post.seo.breadcrumbTitle.includes('&#8211;')) {
		// 	post.seo.breadcrumbTitle = post.seo.breadcrumbTitle.replace('&#8211;', ' – ');
		// }
	}

	post.content += "<fin>";
	useTracking();
	// checkContentTags(post.content);
	return (
		<article
			article
			className="blog-post"
			itemScope
			itemType="http://schema.org/Article"
		>
			<SEO
				title={post.title}
				seoTitle={post.seo.title}
				ogURL={post.seo.opengraphUrl || `https://donotpay.com/learn/${post.slug}/`}
				ogType={post.seo.opengraphType || "article"}
				ogTitle={post.seo.opengraphTitle || post.seo.title}
				ogSiteName={post.seo.opengraphSiteName || "DoNotPay"}
				ogDescription={post.seo?.opengraphDescription || post?.seo?.description}
				metaRobotsNofollow={post.seo.metaRobotsNofollow}
				metaRobotsNoindex={post.seo.metaRobotsNoindex}
				// ogModifiedTime={post.modified}
				// ogPublishedTime={post.date}
				slug={post.slug}
				isPost={true}
				canonical={canonical}
			/>

			{post.author && <PostStructuredData title={post.title} authorName={post?.author?.name} authSlug={post?.author?.slug} />}
			{/* <PostBreadcrumbsStructuredData categorySlug={category.slug} categoryTitle={category.name} postTitle={post.title} /> */}
			{hasSchema(post.slug) && getSchemaForPost(post.slug)}
			<HeroSectionComponent category={category} post={post} dnpUrl={dnpUrl} />
			<PostSection>
				<PostContainer>
					<PostContent>
						<Disclaimer>
							<I>i</I>
							Editorial Note: These blog posts represent the opinion of DoNotPay’s Writers, but each person’s situation and circumstances vary greatly. 
							As a result, you should make sure to do your own independent research. 
							Because everyone is unique, our self-help tools are never guaranteed to help with any specific situation.
							DoNotPay is not a law firm, is not licensed to practice law, and is not equivalent to the services of a licensed lawyer.
							DoNotPay provides a platform for legal information and self-help, and does not offer legal services.
							Third party news articles mentioned on our website do not necessarily reflect the views of the company, or the current services that we offer.
						</Disclaimer>

						<Breadcrumbs>
							<Link aria-label='Breadcrumb' noPrefetch key={post.seo.breadcrumbTitle} style={linkStylesBreadCrumbs} to={`/`}>
								<Breadcrumb >
									<House width="15px" style={alignHouse} /> {'  '}
								</Breadcrumb>
							</Link>
							{/* {post.wpCategoriesConnection.edges.map(({ node }) => ( */}
							<Link aria-label={`Breadcrumb`} noPrefetch key={category.slug} style={linkStylesBreadCrumbs} to={`/${category.slug}/`}>
								<Breadcrumb>
									{' '}
									{symbolParse(category.name)} { }{' '}
								</Breadcrumb>
							</Link>
							{/* ))} */}
							<BreadcrumbNoHover id="start">
								{' '}
								{post.seo.breadcrumbTitle === 'Home' ? undefined : post.seo.breadcrumbTitle} { }{' '}
							</BreadcrumbNoHover>
						</Breadcrumbs>

						{post.author &&
							<AuthorSection>
								<AuthorImage src={post.author?.avatar} /> &nbsp;
								By<Link style={{ textDecoration: "none" }} to={`../authors/${post.author?.slug}/`}><AuthorName>{post.author?.name}</AuthorName></Link>

								<InPostTooltip
									name={post.author?.name}
									description={post.author?.bio}
									isOpen={isOpen}
									expertise={post.author?.expertise}
									avatar={post.author?.avatar}
									setIsOpen={setIsOpen}
									role={post.author?.role}
									authorsPage={`../authors/${post.author?.slug}/`}
								>
									<AuthorDetails onClick={() => (setIsOpen(!isOpen))}>i</AuthorDetails>
								</InPostTooltip>
							</AuthorSection>
						}

						{post.content && <PostBody post={post} />}
					</PostContent>
					<Sidebar>
						<PostSidebar
							dnpUrl={dnpUrl}
							recentPosts={post.category.wpRecentPostsConnection.edges}
							topPosts={post.category.wpTopPostsConnection.edges}
							category={category.name}
						/>
					</Sidebar>
				</PostContainer>
			</PostSection>
			<PostCTA dnpUrl={dnpUrl} />
			<NewFooter />
		</article>
	);
}

const HeroSectionComponent = React.memo(({ category, post, dnpUrl }) => {
	return (
		<HeroBanner>
			<HeroImage>
				<Header dnpUrl={dnpUrl} />
				<HeroContent>
					{category && (
						<Category>
							<Link noPrefetch to={`/${category.slug}/`}>
								{symbolParse(category.name)}
							</Link>
						</Category>
					)}

					{post.title && post.title.length > 50 ? (
						<HeroLongTitle>{symbolParse(post.title)}</HeroLongTitle>
					) : (
						<HeroTitle>{symbolParse(post.title)}</HeroTitle>
					)}

					<HeroButtonContainer>
						{/* <Link to={dnpUrl}> */}
						<HeroButton
							onClick={() => {
								// trackCustomEvent({
								// 	category: 'Learning Center CTA Click',
								// 	action: 'click',
								// 	label: 'Solve This Problem For Me, Post Hero',
								// });
								// trackCustomEvent({
								// 	category: 'Entire page tracker',
								// 	action: 'click',
								// 	label: 'Solve This Problem For Me, Post Hero',
								// });
								document.location = dnpUrl;
							}}
							className="smp-header"
							id="HeroButton"
							aria-label="Get Started"
						>
							Sign up for DoNotPay
						</HeroButton>
						{/* </Link> */}
					</HeroButtonContainer>
					<ButtonA
						aria-label="Scroll to article"
						onClick={() => {
							if (typeof window !== "undefined") {
								window.scroll({
									top: 650,
									left: 0,
									behavior: 'smooth'
								});
							}
						}}>
						<ArrowDown />
					</ButtonA>
				</HeroContent>
			</HeroImage>
		</HeroBanner>
	);
});